import React, { useState, useContext } from "react";
import {
  TextField,
  Typography,
  Container,
  Stack,
  Button,
  Paper,
  Grid,
  InputAdornment,
} from "@mui/material";
import { DataContext } from "../../../../context/DataContext";
import { simpleMessage } from "../../../../helpers/Helpers";
import { deleteToken, deleteUserData, getToken } from "../../../../api/Account";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-regular-svg-icons";
import { addGarantiaAsync, updateGarantiaAsync } from "../../../../api/Credits";

const EditGarantia = ({
  setShowModal,
  localReload,
  setLocalReload,
  selectedGarantia,
  setSelectedGarantia,
}) => {
  const { id } = selectedGarantia;

  const [articulo, setArticulo] = useState(selectedGarantia.articulo);
  const [marca, setMarca] = useState(selectedGarantia.marca);
  const [color, setColor] = useState(selectedGarantia.color);
  const [modelo, setModelo] = useState(selectedGarantia.modelo);
  const [serie, setSerie] = useState(selectedGarantia.serie);
  const [valorEstimado, setValorEstimado] = useState(
    selectedGarantia.valorEstimado
  );

  const { setIsLoading, setIsLogged, setIsUnautorized } =
    useContext(DataContext);

  const token = getToken();

  const funtionSetValorEstimado = (value) => {
    if (/^[0-9]+$/.test(value.toString()) || value === "") {
      setValorEstimado(value);
      return;
    }
  };

  const saveChanges = async () => {
    if (validate()) {
      const data = {
        id,
        articulo,
        marca,
        color,
        modelo,
        serie,
        valorEstimado,
      };

      if (data.marca === "") {
        data.marca = "S/M";
      }

      if (modelo === "") {
        data.modelo = "S/M";
      }

      if (serie === "") {
        data.serie = "S/S";
      }
      setIsLoading(true);

      const result = await updateGarantiaAsync(token, data);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }
      setIsLoading(false);
      simpleMessage("Garantia Actualizada...!", "success");
      setLocalReload(!localReload);
      setShowModal(false);
    }
  };

  const validate = () => {
    let isValid = true;
    if (articulo === "") {
      simpleMessage("Debe ingresar un artículo", "error");
      return (isValid = false);
    }

    if (color === "") {
      simpleMessage("Debe ingresar un color", "error");
      return (isValid = false);
    }

    if (valorEstimado === "" || valorEstimado === 0) {
      simpleMessage("Debe ingresar un valor al artículo", "error");
      return (isValid = false);
    }
    return isValid;
  };

  return (
    <div>
      <Container style={{ width: 550 }}>
        <Paper
          style={{
            padding: 20,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <TextField
                  required
                  fullWidth
                  onChange={(e) => setArticulo(e.target.value.toUpperCase())}
                  value={articulo}
                  label={"Articulo"}
                />
                <TextField
                  fullWidth
                  onChange={(e) => setMarca(e.target.value.toUpperCase())}
                  value={marca}
                  label={"Marca"}
                />
                <TextField
                  required
                  fullWidth
                  onChange={(e) => setColor(e.target.value.toUpperCase())}
                  value={color}
                  label={"Color"}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  onChange={(e) => setModelo(e.target.value.toUpperCase())}
                  value={modelo}
                  label={"Modelo"}
                />
                <TextField
                  fullWidth
                  onChange={(e) => setSerie(e.target.value.toUpperCase())}
                  value={serie}
                  label={"Serie"}
                />
                <TextField
                  required
                  fullWidth
                  onChange={(e) => funtionSetValorEstimado(e.target.value)}
                  value={valorEstimado}
                  label={"Valor estimado"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">C$</InputAdornment>
                    ),
                  }}
                />
              </Stack>
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="outlined"
                startIcon={
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: 20 }} />
                }
                fullWidth
                onClick={() => saveChanges()}
                style={{
                  color: "#00a152",
                  borderColor: "#00a152",
                }}
                size="large"
              >
                Atualizar garantia
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </div>
  );
};

export default EditGarantia;
